import Vue from 'vue'

Vue.mixin({
  methods:  {
    reloadReponsiveTabs() {
      $(".nav-tab-dropdown.hidden-md-up").remove()
      window.Pages && window.Pages.reponsiveTabs();
    },
    changeTabOnMobile: function(tabName) {
      var self = this
      this.reloadReponsiveTabs()
      $(".nav-tab-dropdown.hidden-md-up").find('select').on('change', function() {
        self.selectTab(this.value)
      })
    }
  }
})



// WEBPACK FOOTER //
// ./src/mixin/tabMobile.js